// Helper function to format currency or return $0 if no valid value
export const formatValue = (value) => {
  if (value === null || value === undefined || isNaN(value) || value === 0) {
    return '$0';
  }
  
  // Return formatted currency for valid numbers
  return `$${Number(value).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
};

// Helper function to parse currency input to number
export const parseCurrency = (value) => {
  if (!value) return 0;
  if (typeof value !== 'string') return value;
  
  // Try to extract numeric value from string
  const numericValue = value.replace(/[^0-9.-]+/g, '');
  return numericValue ? Number(numericValue) : 0;
};

// Helper function to group funds by name
export const groupFundsByName = (funds) => {
  const groupedFunds = {};
  funds.forEach((fund, index) => {
    if (!groupedFunds[fund.name]) {
      groupedFunds[fund.name] = {
        name: fund.name,
        values: [],
        type: fund.type
      };
    }
    groupedFunds[fund.name].values.push({
      index: fund.originalApiFundKey !== undefined ? fund.originalApiFundKey : index,
      year2025: fund.year2025,
      year2026: fund.year2026,
      originalApiFundPosition: fund.originalApiFundPosition
    });
  });
  return Object.values(groupedFunds);
};

// Helper function to transform API data to component format
export const transformInstitutionalFundsData = (apiData) => {
  if (!Array.isArray(apiData)) return [];
  
  return apiData.map(apiItem => ({
    name: apiItem.FundName,
    year2025: apiItem.OfferAmount,
    year2026: apiItem.OfferAmount,
    type: 'Stack', // Default type, user can change this in UI
    originalApiFundKey: apiItem.FundKey
  }));
};

// Helper function to transform API response to funds format
export const transformSpecialFundAdjustments = (specialFundAdjustments) => {
  if (!Array.isArray(specialFundAdjustments) || specialFundAdjustments.length === 0) {
    return [];
  }
  
  return specialFundAdjustments.map(adj => ({
    name: adj.fundName,
    year2025: adj.currentYearAmount,
    year2026: adj.nextYearAmount === null || adj.nextYearAmount === undefined ? adj.currentYearAmount : adj.nextYearAmount,
    type: adj.fundType || 'Stack', // Use fundType if available, else default to 'Stack'
    originalApiFundKey: adj.fundKey,
    originalApiFundPosition: adj.fundPosition
  }));
};

// Helper function to transform outside aid API response
export const transformOutsideAidData = (responseData) => ({
  0: responseData.federalGrantAmount || false,
  1: responseData.pellGrantAmount || false,
  2: responseData.stateGrantAmount || false,
  3: responseData.subsidizedLoanAmount || false,
  4: responseData.unsubsidizedLoanAmount || false,
});

// Helper function to create special fund adjustments payload
export const createSpecialFundAdjustmentsPayload = (groupedFunds) => {
  const payload = [];
  
  groupedFunds.forEach(group => {
    group.values.forEach(valueItem => {
      payload.push({
        fundName: group.name,
        fundKey: valueItem.index,
        currentYearAmount: parseCurrency(valueItem.year2025),
        nextYearAmount: parseCurrency(valueItem.year2026),
        fundType: group.type
      });
    });
  });
  
  return payload;
}; 